import React from 'react';
import { RadialBarChart, RadialBar, ResponsiveContainer } from 'recharts';

interface ScoreGaugeProps {
  score: number;    // 0–100
  size?: number;
}

const getColor = (score: number) => {
  if (score >= 80) return '#10b981'; // green
  if (score >= 60) return '#3b82f6'; // blue
  if (score >= 40) return '#f59e0b'; // amber
  return '#ef4444';                   // red
};

export const ScoreGauge: React.FC<ScoreGaugeProps> = ({ score, size = 160 }) => {
  const color = getColor(score);
  const data = [{ value: score, fill: color }];

  return (
    <div className="relative flex flex-col items-center" style={{ width: size, height: size }}>
      <ResponsiveContainer width="100%" height="100%">
        <RadialBarChart
          cx="50%"
          cy="50%"
          innerRadius="70%"
          outerRadius="100%"
          startAngle={210}
          endAngle={-30}
          data={[{ value: 100, fill: '#e5e7eb' }, ...data]}
        >
          <RadialBar dataKey="value" cornerRadius={6} background={false} />
        </RadialBarChart>
      </ResponsiveContainer>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span className="text-3xl font-bold" style={{ color }}>{score.toFixed(1)}</span>
        <span className="text-xs text-gray-500">/ 100</span>
      </div>
    </div>
  );
};
